import { createFetcher } from "api/helpers"
const fetcherConfiguration = {
  method: "get",
  makeRequestUrl: (host, project) => {
    return `${host}/avantra/${project}/get_avantra_url`
  },
  checkRequiredArguments: () => {
    // if (params === undefined) console.log("No params data supplied.");
  },
  makeResponseData: () => {
    return [{ okta_url: "test_url" }]
  }
}
export default createFetcher(fetcherConfiguration)
